<script>
import axios from "axios";
import BaseTypeAhead from "./BaseTypeAhead";

export default {
  name: "BaseAjaxTypeAhead",
  extends: BaseTypeAhead,
  props: {
    url: {
      type: String,
      required: true
    },
    api: {
      type: Object,
      default: null
    },
    apiMethod: {
      type: String,
      default: "getList"
    },
    onInputChange: {
      type: Function,
      default(query) {
        if (this.api === null) {
          return axios
            .get(this.url.replace("%query", query))
            .then(response => response.data.results);
        } else {
          return this.api[this.apiMethod]({ query }).then(
            response => response.results
          );
        }
      }
    }
  },
  methods: {}
};
</script>
